"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTaskEstimationChangelogEvent = void 0;
const task_1 = require("./task");
function isTaskEstimationChangelogEvent(type) {
    return type === task_1.IssueChangelogEventType.OriginalTimeEstimate
        || type === task_1.IssueChangelogEventType.StoryPoints
        || type === task_1.IssueChangelogEventType.TShirtSize;
}
exports.isTaskEstimationChangelogEvent = isTaskEstimationChangelogEvent;
//# sourceMappingURL=issue-changelog.js.map